import React from 'react';
import { AwardIcon, ShieldCheckIcon } from 'lucide-react';
import { ownerData } from '../data/sampleData';
interface CertificateCardProps {
  onClick: () => void;
  t: (key: string) => string;
}
export function CertificateCard({
  onClick,
  t
}: CertificateCardProps) {
  return <div onClick={onClick} className="relative overflow-hidden bg-gradient-to-br from-[#006A4E] to-[#004d38] rounded-2xl shadow-lg cursor-pointer hover:shadow-xl transition-all group h-full" data-id="element-37">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 -mt-4 -mr-4 w-32 h-32 bg-white/10 rounded-full blur-2xl group-hover:bg-white/20 transition-all" data-id="element-38"></div>
      <div className="absolute bottom-0 left-0 -mb-8 -ml-8 w-40 h-40 bg-[#D4A843]/20 rounded-full blur-2xl" data-id="element-39"></div>

      <div className="relative p-6 text-white h-full flex flex-col" data-id="element-40">
        <div className="flex justify-between items-start mb-6" data-id="element-41">
          <div className="flex items-center gap-2" data-id="element-42">
            <div className="p-2 bg-white/20 rounded-lg backdrop-blur-sm" data-id="element-43">
              <AwardIcon className="w-6 h-6 text-[#D4A843]" data-id="element-44" />
            </div>
            <div data-id="element-45">
              <h3 className="font-bold text-lg leading-tight" data-id="element-46">
                {t('certificate.title')}
              </h3>
              <p className="text-green-100 text-xs" data-id="element-47">Govt. of Bangladesh</p>
            </div>
          </div>
          <div className="flex items-center gap-1 bg-green-500/20 border border-green-400/30 px-2 py-1 rounded text-xs font-medium backdrop-blur-sm shrink-0" data-id="element-48">
            <ShieldCheckIcon className="w-3 h-3 text-green-300" data-id="element-49" />
            <span className="text-green-100" data-id="element-50">{t('certificate.verified')}</span>
          </div>
        </div>

        <div className="space-y-4 flex-1" data-id="element-51">
          <div data-id="element-52">
            <p className="text-green-200 text-xs mb-1" data-id="element-53">
              {t('certificate.ownerName')}
            </p>
            <p className="font-bold text-xl" data-id="element-54">{ownerData.name}</p>
          </div>

          <div className="grid grid-cols-2 gap-4" data-id="element-55">
            <div data-id="element-56">
              <p className="text-green-200 text-xs mb-1" data-id="element-57">
                {t('certificate.ownerId')}
              </p>
              <p className="font-mono text-sm" data-id="element-58">{ownerData.landOwnerId}</p>
            </div>
            <div data-id="element-59">
              <p className="text-green-200 text-xs mb-1" data-id="element-60">
                {t('certificate.certNo')}
              </p>
              <p className="font-mono text-sm" data-id="element-61">{ownerData.certificateNo}</p>
            </div>
          </div>
        </div>

        <div className="mt-6 pt-4 border-t border-white/20 flex justify-between items-center" data-id="element-62">
          <p className="text-xs text-green-200" data-id="element-63">
            {t('certificate.clickToView')}
          </p>
          <div className="w-8 h-8 rounded bg-white/10 flex items-center justify-center shrink-0" data-id="element-64">
            <div className="w-4 h-4 border-2 border-white/50 border-t-white rounded-full animate-spin" style={{
            animationDuration: '3s'
          }} data-id="element-65"></div>
          </div>
        </div>
      </div>
    </div>;
}